import { render } from "./uploader.vue?vue&type=template&id=2da336fe&ts=true"
import script from "./uploader.vue?vue&type=script&lang=ts"
export * from "./uploader.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/simon/www/earth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__